var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSliderArrowRight = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_269_5318)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_269_5318)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    width: 38,
    height: 38,
    rx: 10,
    fill: "#21262A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 0.5,
    width: 38,
    height: 38,
    rx: 9.5,
    stroke: "#2C3555"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.3262 25.8082L30.7513 20.0245C31.2709 19.4573 31.2759 18.5477 30.7501 17.9739L25.3263 12.1914C24.7889 11.6184 23.9174 11.6185 23.3799 12.1914C22.8424 12.7644 22.8424 13.6934 23.3799 14.2664L26.4438 17.5326H16.2332C15.4731 17.5326 14.857 18.1895 14.857 18.9998C14.857 19.8101 15.4731 20.467 16.2332 20.467H26.4438L23.3799 23.7333C22.8424 24.3062 22.8424 25.2352 23.3799 25.8082C23.9172 26.3811 24.7887 26.3812 25.3262 25.8082Z",
    fill: "white"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSliderArrowRight);
export default ForwardRef;